module.exports = __webpack_public_path__ + "static/media/woman-finished-appointment.f14e4c02.svg";